import React from "react";
import { Provider } from "react-redux";
import { UserProvider } from "@auth0/nextjs-auth0/client";
import PropTypes from "prop-types";
import { NuqsAdapter } from "nuqs/adapters/next/pages";
import { MsalProvider } from "@azure/msal-react";

import { initializeStore } from "@/redux/store";
import { pagePropsShape } from "@/utils/propTypeShapes";
import "../styles/globals.css";
import { NotificationBus } from "@/components/notification/notification_bus";
import { msalInstance } from "@/integrations/microsoft_graph";
import initializeIntegrations from "@/integrations/index";
import { Modal } from "@/components/modals/modal";
import { SlideOver } from "@/components/slide_over/slide_over";
import ErrorBoundary from "@/components/error/ErrorBoundary";
import RouteChangeLoader from "@/components/route-change-loader/RouteChangeLoader";
import { ApplicationInsightsProvider } from "@/components/providers/ApplicationInsightsProvider";
import { OverlayProvider } from "@/components/overlays";

initializeIntegrations();

const store = initializeStore();

function App({ Component, pageProps }) {
  const { user } = pageProps;

  return (
    <ErrorBoundary>
      <ApplicationInsightsProvider>
        <MsalProvider instance={msalInstance}>
          <UserProvider user={user}>
            <Provider store={store}>
              <NuqsAdapter>
                <NotificationBus>
                  <OverlayProvider>
                    <RouteChangeLoader />
                    <Component {...pageProps} />
                    <SlideOver>
                      <Modal />
                    </SlideOver>
                  </OverlayProvider>
                </NotificationBus>
              </NuqsAdapter>
            </Provider>
          </UserProvider>
        </MsalProvider>
      </ApplicationInsightsProvider>
    </ErrorBoundary>
  );
}

export default App;

App.propTypes = {
  Component: PropTypes.func.isRequired,
  pageProps: pagePropsShape,
};
